export enum OnboardingState {
  Name = "name",
  ProfilePhoto = "profilePhoto",
  Gender = "gender",
  PushNotifications = "pushNotifications",
}
